import React from 'react';
import { CustomModal } from '../../../../../common/CustomModal';
import '../../../../../../styles/components/auction-client-pay.scss';
import { TableSkeleton } from '../../../../../common/skelton/TableSkelton';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../../../styles/components/js/tableStyle';
import i18n from '../../../../../../i18n';
import NoData from '../../../../../common/NoData';
import ProjectCardSkeleton from '../../../../../common/skelton/ProjectCardSkelton';
import ProjectCard from '../../../../../common/ProjectCard';
import { BanknoteArrowDown, BanknoteArrowUp } from 'lucide-react';
import { getCashflowTransactions } from '../../services/cashFlowService';
import { formatDate } from '../../../../../../utils/common';

export class EnrollmentList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      isloading: false,
      meta: null,
      page: 1,
      limit: 15,
      total: 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.fetchPayments();
    }
  }

  fetchPayments = async () => {
    const { method, search } = this.props;
    this.setState({ isloading: true });
    try {
      let { limit, page } = this.state;
      const q = {
        page: page,
        limit: limit,
        type: 'enrollment',
      };
      if (method) q.method = method.toLowerCase();
      if (search?.startDate) {
        q.startDate = search.startDate;
      }

      if (search?.endDate) {
        q.endDate = search.endDate;
      }

      if (search?.client) {
        q.client = search.client;
      }

      if (search?.group) {
        q.group = search.group;
      }

      if (search?.bidder) {
        q.bidder = search.bidder;
      }
      const response = await getCashflowTransactions(q);

      if (response.success) {
        this.setState({
          transactions: response.data,
          total: response.meta.total,
          meta: response.meta,
          isloading: false,
        });
      } else {
        this.setState({ isloading: false });
      }
    } catch {
      this.setState({ isloading: false });
    }
  };

  getColumns = () => {
    return [
      {
        name: i18n.t('sl'),
        width: '80px',
        sortable: true,
        cell: (row, index) => (this.state.page - 1) * this.state.limit + index + 1,
      },

      {
        name: i18n.t('bidder_id'),
        minWidth: '130px',
        sortable: true,
        cell: (row) => <span className="highlight-table-value">{row.user}</span>,
      },

      {
        name: i18n.t('bidder_name'),
        minWidth: '180px',
        sortable: true,
        cell: (row) => row.user_relation?.name,
      },
      {
        name: i18n.t('client_name'),
        width: '120px',
        cell: (row) => (
          <span className="highlight-table-value">{row.group?.organization_details?.organization_name || '-'}</span>
        ),
      },
      {
        name: i18n.t('group_id'),
        minWidth: '130px',
        sortable: true,
        cell: (row) => <span className="highlight-table-value">{row.group_id}</span>,
      },

      {
        name: i18n.t('payment_method'),
        minWidth: '180px',
        cell: (row) => row.group.group_name,
      },

      {
        name: i18n.t('amount'),
        width: '140px',
        sortable: true,
        right: true,
        cell: (row) => <span className="amount-text success">OMR {Number(row.debit).toFixed(3)}</span>,
      },

      {
        name: i18n.t('payment_method'),
        minWidth: '140px',
        cell: (row) => {
          const method = row.method;

          const label = method === 'online' ? 'Online' : method === 'offline' ? 'Offline' : 'Wallet';

          return <span className={`payment-method ${method}`}>{label}</span>;
        },
      },
      {
        name: i18n.t('transaction_date'),
        minWidth: '150px',
        sortable: true,
        cell: (row) => formatDate(row.created_at),
      },

      {
        name: i18n.t('status'),
        width: '120px',
        center: true,
        cell: (row) => {
          const status = row.status?.toLowerCase();

          return <span className={`status-badge ${status}`}>{status === 'a' ? 'Approved' : 'Pending'}</span>;
        },
      },
    ];
  };

  handleCancel = () => {
    this.setState({
      transactions: [],
    });
    this.props.onClose();
  };

  onChangePage = (page) => {
    this.setState({ page }, () => {
      this.fetchPayments();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit, page: 1 }, () => {
      this.fetchPayments();
    });
  };

  render() {
    const { show, method } = this.props;
    const { transactions } = this.state;
    const { meta } = this.state;

    const title =
      method === 'online'
        ? i18n.t('online_enrollment')
        : method === 'offline'
          ? i18n.t('offline_enrollment')
          : i18n.t('all_enrollment');

    let summaryCards = [];
    if (method === 'online') {
      summaryCards = [
        {
          title: i18n.t('online_payment'),
          amount: meta?.methods?.online?.debit || 0,
          value: meta?.methods?.online?.count || 0,
          valueLabel: i18n.t('transactions'),
          icon: BanknoteArrowUp,
          className: 'Approved',
        },
      ];
    } else if (method === 'offline') {
      summaryCards = [
        {
          title: i18n.t('offline_payment'),
          amount: meta?.methods?.offline?.debit || 0,
          value: meta?.methods?.offline?.count || 0,
          valueLabel: i18n.t('transactions'),
          icon: BanknoteArrowDown,
          className: 'Rejected',
        },
      ];
    } else {
      summaryCards = [
        {
          title: i18n.t('online_enrollment'),
          amount: meta?.methods?.online?.debit || 0,
          value: meta?.methods?.online?.count || 0,
          valueLabel: i18n.t('transactions'),
          icon: BanknoteArrowUp,
          className: 'Approved',
        },
        {
          title: i18n.t('offline_enrollment'),
          amount: meta?.methods?.offline?.debit || 0,
          value: meta?.methods?.offline?.count || 0,
          valueLabel: i18n.t('transactions'),
          icon: BanknoteArrowDown,
          className: 'Rejected',
        },
      ];
    }

    return (
      <CustomModal isOpen={show} header={title} onClose={this.handleCancel} modalClassName="modal-l2-xl">
        <div className="summary-report">
          <div className="summary-report__content">
            {this.state.isSummaryLoading
              ? [...Array(3)].map((_, idx) => <ProjectCardSkeleton key={idx} />)
              : summaryCards.map((item, idx) => {
                  const Icon = item.icon;

                  return (
                    <ProjectCard
                      key={idx}
                      className={item.className}
                      icon={Icon}
                      title={item.title}
                      amount={item.amount}
                      value={item.value}
                      valueLabel={item.valueLabel}
                    />
                  );
                })}
          </div>
        </div>
        <div className="Data-Listing">
          {this.state.isloading ? (
            <TableSkeleton columns={5} rows={2} />
          ) : transactions.length ? (
            <DataTable
              keyField={(row) => `${row.id}`}
              responsive={true}
              columns={this.getColumns()}
              data={transactions}
              customStyles={tableStyles}
              highlightOnHover
              pointerOnHover
              pagination
              paginationServer
              paginationTotalRows={this.state.total}
              paginationPerPage={this.state.limit}
              paginationDefaultPage={this.state.page}
              paginationRowsPerPageOptions={[15, 25, 50, 100]}
              paginationComponentOptions={{
                rowsPerPageText: i18n.t('rows_per_page'),
                rangeSeparatorText: i18n.t('out'),
              }}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          ) : (
            <NoData message={i18n.t('no_transaction_available')} />
          )}
        </div>
      </CustomModal>
    );
  }
}
